import type { TrackingSpecs } from '@/libraries/tracking/specTracker';

import { LoginProvider, UserAccountEvents } from './types';
import { createSpecTracker, defineSpec } from '@/libraries/tracking/specTracker';

import { useUserStore } from '@/helpers/composables/useStores';
import { SnowplowLoginContext } from '@/helpers/tracking/providers/snowplow-contexts';

import { computed } from 'vue';

const specs = {
	login: defineSpec<{
		property: `${string}_${string}` | string;
		label: string;
	}>()({
		action: UserAccountEvents.LOGIN,
	}),

	loginError: defineSpec<{
		property: LoginProvider;
		label: string;
	}>()({
		action: UserAccountEvents.LOGIN_ERROR,
	}),

	signUp: defineSpec<{
		property: `${string}_${string}` | string;
		label: string;
	}>()({
		action: UserAccountEvents.SIGNUP,
	}),

	signUpError: defineSpec<{
		property: LoginProvider;
		label: string;
	}>()({
		action: UserAccountEvents.SIGNUP_ERROR,
	}),

	dataProtectionSubmitted: {
		action: 'account_settings_submitted',
		label: 'data_protection',
		property: 'settings',
	},

	interestEmailsSubmitted: defineSpec<{ value: 1 | 0 }>()({
		action: 'account_settings_submitted',
		label: 'interest_emails',
		property: 'settings',
	}),
} satisfies TrackingSpecs;

export function useAuthTracking() {
	const { jwLoginId } = useUserStore();

	const loginContext = computed(() => (jwLoginId.value ? new SnowplowLoginContext(jwLoginId.value) : undefined));

	const trackAuth = createSpecTracker({
		specs,
		baseProperties: { category: 'user_account' },
		baseContexts: () => [loginContext.value],
	});

	return { trackAuth };
}
